export const localStorageRootKey = 'ordee_system_admin';
export const defaultPaths = {
  guest: '/login',
  authorized: '/',
};
